import React, { Component } from 'react'

class Canvas extends Component {
	render() {
		return (
			<React.Fragment>
				<div id='canvas-container' className='Canvas h-100'>
				</div>
				<div style={{ // white fade out on the sides of the canvas
					position: 'absolute',
					top: 0,
					width: '100%',
					height: '100%',
					boxShadow: 'inset 0 0 50px 25px white',
					pointerEvents: 'none',
				}}></div>
			</React.Fragment>
		)
	}
}

export default Canvas



// WEBPACK FOOTER //
// ./src/components/Canvas.js